import React, { useState } from 'react';
import {
    Table, Button, Space, Typography, Tag, message, Modal, Form,
    Input, Select, Drawer, Card, Tabs, Alert, InputNumber
} from 'antd';
import { PlusOutlined, DeleteOutlined, ExclamationCircleFilled, SearchOutlined, ReloadOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

// TODO: 联调时替换为接口数据
const MOCK_ENTERPRISES = [
    { entId: 'ENT_001', entName: '深圳智联科技有限公司' },
    { entId: 'ENT_002', entName: '北京安视智能科技' },
    { entId: 'ENT_003', entName: '上海物联网科技集团' },
];

const MOCK_PRODUCTS_BY_ENT = {
    'ENT_001': [
        { pid: 'PID_100234', pname: 'IPC Pro 标准版' },
        { pid: 'PID_200891', pname: 'IPC Lite 简易版' },
    ],
    'ENT_002': [
        { pid: 'PID_305672', pname: '智能门锁标准版' },
        { pid: 'PID_412038', pname: '智能插座Pro' },
    ],
    'ENT_003': [
        { pid: 'PID_523149', pname: '云台摄像机旗舰版' },
    ],
};

// 广告策略选项（精准广告策略），由数仓提供
// TODO: 联调时替换为接口数据
const AD_STRATEGY_OPTIONS = [
    { value: 'AD0', label: '完全无广告(AD0)' },
    { value: 'EXP', label: '注重客户体验(EXP)' },
    { value: 'AD1', label: '轻度广告(AD1)' },
    { value: 'PRO', label: '收益为主(PRO)' },
];

const renderAdStrategy = (key) => {
    const opt = AD_STRATEGY_OPTIONS.find(o => o.value === key);
    return opt ? <Tag color="blue" style={{ border: 'none' }}>{opt.label}</Tag> : <Text type="secondary">—</Text>;
};

const MOCK_PRODUCT_WHITELIST = [
    { id: '1', pid: 'PID_100234', pname: 'IPC Pro 标准版', entId: 'ENT_001', entName: '深圳智联科技有限公司', adStrategy: 'AD0' },
    { id: '2', pid: 'PID_200891', pname: 'IPC Lite 简易版', entId: 'ENT_001', entName: '深圳智联科技有限公司', adStrategy: 'EXP' },
    { id: '3', pid: 'PID_412038', pname: '智能插座Pro', entId: 'ENT_002', entName: '北京安视智能科技', adStrategy: 'PRO' },
];

const MOCK_USER = [
    { id: '1', uid: 'UID_100234', account: 'user_zhang@example.com', days: 365, endTime: '2025-01-10', remark: 'VIP客户免广', adStrategy: 'AD0' },
    { id: '2', uid: 'UID_200891', account: 'user_li@example.com', days: null, endTime: '永久', remark: '', adStrategy: 'AD1' },
    { id: '3', uid: 'UID_305672', account: 'user_wang@example.com', days: 30, endTime: '2024-07-18', remark: '测试账号', adStrategy: 'PRO' },
    { id: '4', uid: 'UID_523149', account: 'user_huang@example.com', days: null, endTime: '永久', remark: '', adStrategy: 'EXP' },
];

// ══════════════════════════════════════════════
//  添加产品抽屉（级联选择）
// ══════════════════════════════════════════════
const AddProductDrawer = ({ open, onCancel, onSubmit, existingPids }) => {
    const [form] = Form.useForm();
    const [selectedEnt, setSelectedEnt] = useState(null);
    const [selectedPid, setSelectedPid] = useState(null);
    const products = selectedEnt ? (MOCK_PRODUCTS_BY_ENT[selectedEnt] || []) : [];

    React.useEffect(() => { if (open) { form.resetFields(); setSelectedEnt(null); setSelectedPid(null); } }, [open, form]);

    const handleEntChange = (entId) => {
        setSelectedEnt(entId);
        setSelectedPid(null);
        form.setFieldValue('pid', undefined);
        if (entId) {
            const ent = MOCK_ENTERPRISES.find(e => e.entId === entId);
            form.setFieldValue('entName', ent?.entName || '');
        }
    };

    const handlePidChange = (pid) => {
        setSelectedPid(pid);
    };

    const handleSubmit = async () => {
        const values = await form.validateFields();
        const duplicate = existingPids.includes(values.pid);
        if (duplicate) {
            message.warning('该产品已配置，此次操作将被忽略');
            onCancel();
            return;
        }
        const ent = MOCK_ENTERPRISES.find(e => e.entId === values.entId);
        const prod = products.find(p => p.pid === values.pid);
        onSubmit({
            pid: values.pid,
            pname: prod?.pname || '',
            entId: values.entId,
            entName: ent?.entName || '',
            adStrategy: values.adStrategy,
        });
        form.resetFields();
        setSelectedEnt(null);
        setSelectedPid(null);
    };

    return (
        <Drawer title="添加产品" open={open} width={480}
            onClose={() => { onCancel(); setSelectedEnt(null); setSelectedPid(null); }}
            footer={<Space style={{ float: 'right' }}><Button onClick={onCancel}>取消</Button><Button type="primary" onClick={handleSubmit}>确认添加</Button></Space>}
        >
            <Form form={form} layout="vertical">
                <Form.Item name="entId" label="选择企业" rules={[{ required: true, message: '请选择企业' }]}>
                    <Select placeholder="请选择企业" showSearch allowClear
                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                        onChange={handleEntChange}
                    >
                        {MOCK_ENTERPRISES.map(e => <Select.Option key={e.entId} value={e.entId}>{e.entName}</Select.Option>)}
                    </Select>
                </Form.Item>
                {selectedEnt && (
                    <Form.Item label="企业ID"><Input value={selectedEnt} disabled /></Form.Item>
                )}
                <Form.Item name="pid" label="选择产品" rules={[{ required: true, message: '请选择产品' }]}>
                    <Select placeholder={selectedEnt ? '请选择产品' : '请先选择企业'} disabled={!selectedEnt} showSearch
                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                        onChange={handlePidChange}
                    >
                        {products.map(p => <Select.Option key={p.pid} value={p.pid}>{p.pname}</Select.Option>)}
                    </Select>
                </Form.Item>
                {selectedPid && (
                    <Form.Item label="产品ID"><Input value={selectedPid} disabled /></Form.Item>
                )}
                {selectedPid && (
                    <Form.Item name="adStrategy" label="广告策略" rules={[{ required: true, message: '请选择广告策略' }]}>
                        <Select placeholder="请选择广告策略" options={AD_STRATEGY_OPTIONS} />
                    </Form.Item>
                )}
                <Form.Item name="entName" hidden><Input /></Form.Item>
            </Form>
        </Drawer>
    );
};

// ══════════════════════════════════════════════
//  添加用户抽屉（UID文本域批量）
// ══════════════════════════════════════════════
const AddUserDrawer = ({ open, onCancel, onSubmit, existingUids }) => {
    const [form] = Form.useForm();
    React.useEffect(() => { if (open) form.resetFields(); }, [open, form]);

    const handleSubmit = async () => {
        const values = await form.validateFields();
        const uids = values.uidText.split('\n').map(u => u.trim()).filter(Boolean);
        const newUids = [];
        const skippedUids = [];
        uids.forEach(uid => {
            if (existingUids.includes(uid)) {
                skippedUids.push(uid);
            } else {
                newUids.push(uid);
            }
        });
        if (skippedUids.length > 0) {
            message.warning(`已配置的 ${skippedUids.length} 个 UID 将被忽略：${skippedUids.join(', ')}`);
        }
        if (newUids.length > 0) {
            message.success(`已添加 ${newUids.length} 个 UID`);
        }
        const days = values.days;
        const endTime = days ? new Date(Date.now() + days * 86400000).toISOString().slice(0, 10) : '永久';
        onSubmit(newUids.map(uid => ({
            uid,
            account: '—',
            days: days || null,
            endTime,
            remark: values.remark || '',
            adStrategy: values.adStrategy,
        })));
        form.resetFields();
    };

    return (
        <Drawer title="添加用户" open={open} width={480}
            onClose={onCancel}
            footer={<Space style={{ float: 'right' }}><Button onClick={onCancel}>取消</Button><Button type="primary" onClick={handleSubmit}>确认添加</Button></Space>}
        >
            <Form form={form} layout="vertical">
                <Form.Item name="uidText" label="用户UID" rules={[{ required: true, message: '请输入用户UID' }]}
                    extra="每行输入一个 UID，支持批量添加">
                    <Input.TextArea rows={6} placeholder={'UID_100234\nUID_200891\nUID_305672'} />
                </Form.Item>
                <Form.Item name="adStrategy" label="广告策略" rules={[{ required: true, message: '请选择广告策略' }]}>
                    <Select placeholder="请选择广告策略" options={AD_STRATEGY_OPTIONS} />
                </Form.Item>
                <Form.Item name="days" label="生效时长（天）" extra="不填则永久生效">
                    <InputNumber min={1} placeholder="请输入天数" style={{ width: '100%' }} />
                </Form.Item>
                <Form.Item name="remark" label="备注">
                    <Input placeholder="请输入备注（选填）" />
                </Form.Item>
            </Form>
        </Drawer>
    );
};

// ══════════════════════════════════════════════
//  主组件：精准广告策略
// ══════════════════════════════════════════════
const AdWhitelist = () => {
    const [activeTab, setActiveTab] = useState('product');
    const [productWhitelist, setProductWhitelist] = useState(MOCK_PRODUCT_WHITELIST);
    const [userWhitelist, setUserWhitelist] = useState(MOCK_USER);
    const [drawerOpen, setDrawerOpen] = useState(false);

    // 产品级筛选
    const [productSearchType, setProductSearchType] = useState('entName');
    const [productKeyword, setProductKeyword] = useState('');
    const [prodInfoSearchType, setProdInfoSearchType] = useState('pname');
    const [prodInfoKeyword, setProdInfoKeyword] = useState('');
    // 用户级筛选
    const [userSearchType, setUserSearchType] = useState('uid');
    const [userKeyword, setUserKeyword] = useState('');

    const handleAdd = () => { setDrawerOpen(true); };

    const handleProductSubmit = (values) => {
        setProductWhitelist(prev => [...prev, { id: Date.now().toString(), ...values }]);
        message.success('添加成功');
        setDrawerOpen(false);
    };

    const handleUserSubmit = (newUsers) => {
        setUserWhitelist(prev => [...prev, ...newUsers.map((u, i) => ({ id: Date.now().toString() + i, ...u }))]);
        setDrawerOpen(false);
    };

    const handleDelete = (type, id) => {
        Modal.confirm({
            title: '确定移除该策略记录吗？', icon: <ExclamationCircleFilled />,
            okText: '确定', okType: 'danger', cancelText: '取消',
            onOk: () => {
                if (type === 'product') setProductWhitelist(prev => prev.filter(p => p.id !== id));
                else if (type === 'user') setUserWhitelist(prev => prev.filter(u => u.id !== id));
                message.success('已移除');
            },
        });
    };

    // ═══ 产品级 表格列 ═══
    const filteredProducts = productWhitelist.filter(p => {
        const entField = productSearchType === 'entName' ? p.entName : p.entId;
        const entMatch = !productKeyword || entField.toLowerCase().includes(productKeyword.toLowerCase());
        const prodField = prodInfoSearchType === 'pname' ? p.pname : p.pid;
        const prodMatch = !prodInfoKeyword || prodField.toLowerCase().includes(prodInfoKeyword.toLowerCase());
        return entMatch && prodMatch;
    });
    const filteredPids = productWhitelist.map(p => p.pid);

    const productCols = [
        {
            title: '企业信息', key: 'ent',
            render: (_, r) => <><Text strong>{r.entName}</Text><br /><Text copyable code>{r.entId}</Text></>,
        },
        {
            title: '产品信息', key: 'prod',
            render: (_, r) => <><Text strong>{r.pname}</Text><br /><Text copyable code>{r.pid}</Text></>,
        },
        {
            title: '广告策略', dataIndex: 'adStrategy', width: 160,
            render: (t) => renderAdStrategy(t),
        },
        {
            title: '操作', key: 'action', fixed: 'right',
            render: (_, r) => <Button type="link" danger size="small" icon={<DeleteOutlined />} onClick={() => handleDelete('product', r.id)}>删除</Button>,
        },
    ];

    // ═══ 用户级 表格列 ═══
    const filteredUsers = userWhitelist.filter(u => {
        if (!userKeyword) return true;
        const field = userSearchType === 'uid' ? u.uid : u.account;
        return field.toLowerCase().includes(userKeyword.toLowerCase());
    });
    const filteredUserUids = userWhitelist.map(u => u.uid);

    const userCols = [
        { title: '用户ID', dataIndex: 'uid', render: (t) => <Text copyable code>{t}</Text> },
        { title: '用户账号', dataIndex: 'account', render: (t) => <Text>{t}</Text> },
        { title: '广告策略', dataIndex: 'adStrategy', width: 160, render: (t) => renderAdStrategy(t) },
        { title: '有效期', dataIndex: 'days', render: (t) => t ? <Text>{t}天</Text> : <span style={{ color: '#ccc' }}>—</span> },
        { title: '结束时间', dataIndex: 'endTime', render: (t) => t === '永久' ? <Tag color="green" style={{ border: 'none' }}>永久</Tag> : <Text type="secondary">{t}</Text> },
        { title: '备注', dataIndex: 'remark', render: (t) => <Text type="secondary">{t || <span style={{ color: '#ccc' }}>—</span>}</Text> },
        {
            title: '操作', key: 'action', fixed: 'right',
            render: (_, r) => <Button type="link" danger size="small" icon={<DeleteOutlined />} onClick={() => handleDelete('user', r.id)}>删除</Button>,
        },
    ];

    // ═══ 过滤组件 ═══
    const ProductFilter = () => (
        <div style={{ marginBottom: 16 }}>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 8 }}>
                <Select value={productSearchType} onChange={setProductSearchType} style={{ width: 130 }}>
                    <Select.Option value="entName">企业名称</Select.Option>
                    <Select.Option value="entId">企业ID</Select.Option>
                </Select>
                <Input placeholder="企业名称/ID" allowClear style={{ width: 240 }} value={productKeyword} onChange={e => setProductKeyword(e.target.value)} />
                <Select value={prodInfoSearchType} onChange={setProdInfoSearchType} style={{ width: 130 }}>
                    <Select.Option value="pname">产品名称</Select.Option>
                    <Select.Option value="pid">产品ID</Select.Option>
                </Select>
                <Input placeholder="产品名称/ID" allowClear style={{ width: 240 }} value={prodInfoKeyword} onChange={e => setProdInfoKeyword(e.target.value)} />
                <Button icon={<SearchOutlined />}>查询</Button>
                <Button icon={<ReloadOutlined />} onClick={() => { setProductKeyword(''); setProductSearchType('entName'); setProdInfoKeyword(''); setProdInfoSearchType('pname'); }}>重置</Button>
            </div>
        </div>
    );

    const UserFilter = () => (
        <div style={{ marginBottom: 16, display: 'flex', gap: 8, alignItems: 'center' }}>
            <Select value={userSearchType} onChange={setUserSearchType} style={{ width: 130 }}>
                <Select.Option value="uid">UID</Select.Option>
                <Select.Option value="account">用户账号</Select.Option>
            </Select>
            <Input placeholder="请输入关键字" allowClear style={{ width: 240 }} value={userKeyword} onChange={e => setUserKeyword(e.target.value)} />
            <Button icon={<SearchOutlined />} onClick={() => {}}>查询</Button>
            <Button icon={<ReloadOutlined />} onClick={() => { setUserKeyword(''); setUserSearchType('uid'); }}>重置</Button>
        </div>
    );

    const tabItems = [
        {
            key: 'product', label: '产品级',
            children: (
                <>
                    <ProductFilter />
                    <Table columns={productCols} dataSource={filteredProducts} rowKey="id" bordered={false}
                        pagination={filteredProducts.length > 10 ? { showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` } : false}
                        locale={{ emptyText: '暂无策略记录' }}
                    />
                </>
            ),
        },
        {
            key: 'user', label: '用户级',
            children: (
                <>
                    <UserFilter />
                    <Table columns={userCols} dataSource={filteredUsers} rowKey="id" bordered={false}
                        pagination={filteredUsers.length > 10 ? { showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` } : false}
                        locale={{ emptyText: '暂无策略记录' }}
                    />
                </>
            ),
        },
    ];

    return (
        <div style={{ padding: 24 }}>
            <Title level={4} style={{ marginBottom: 16 }}>精准广告策略</Title>
            <Alert
                message="可按照产品级（产品ID）、用户级（UID）添加去高度自定义广告策略。添加完成后，已添加产品下的所有设备、指定用户均将在 App 端按当前配置高度自定义策略优先生效。"
                type="info" showIcon closable
                style={{ marginBottom: 16, borderRadius: 8 }}
            />
            <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
                <Tabs activeKey={activeTab} onChange={setActiveTab}
                    tabBarExtraContent={
                        <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>
                            {activeTab === 'product' ? '添加产品' : '添加用户'}
                        </Button>
                    }
                    items={tabItems}
                />
            </Card>

            {drawerOpen && activeTab === 'product' && (
                <AddProductDrawer open={drawerOpen} onCancel={() => setDrawerOpen(false)} onSubmit={handleProductSubmit} existingPids={filteredPids} />
            )}
            {drawerOpen && activeTab === 'user' && (
                <AddUserDrawer open={drawerOpen} onCancel={() => setDrawerOpen(false)} onSubmit={handleUserSubmit} existingUids={filteredUserUids} />
            )}
        </div>
    );
};

export default AdWhitelist;
